export default "__VITE_ASSET__89003a2e__"